import React from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import { Grid } from "react-bootstrap";
import cx from "classnames";

import s from "../Home/NewsBox/NewsBox.css";
import l from "./Skeleton.css";
import Shimmer from "./Shimmer";

function NewsBoxSkeleton() {
    return (
        <Grid fluid>
            <div className={cx(s.bg, 'newsBoxBorderRadius', 'bgBlackTwo')}>
                <div className={l.newsBoxOneSkeletonMain}>
                    <Shimmer />
                </div>
                <div className={cx(l.newsSkeletonPosition, 'newsSkeletonPositionRTL')}>
                    <div className={cx(l.newsBoxOneSkeleton, 'bgBlackTwo', 'newsBoxDark')}>
                        <Shimmer />
                    </div>
                    <div
                        className={cx(
                            l.newsBoxOneSkeleton,
                            'bgBlackTwo',
                            'hidden-xs',
                            'newsBoxOneSkeletonRTL'
                        )}
                        style={{ width: 245, marginLeft: 25 }}
                    >
                        <Shimmer />
                    </div>
                </div>
            </div>
        </Grid>
    );
}

export default withStyles(s)(NewsBoxSkeleton);
